module.exports = __webpack_public_path__ + "media/images/google-icon-d4a4a5c3bd8a3b55a89b67af9fd637a3.png";